import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { api } from '../lib/api.js'
import { DataTable, Pager } from '../components/DataTable.jsx'

const fmtDate = (v) => (v ? new Date(v).toLocaleDateString('tr-TR') : '-')

export function Users() {
  const [q, setQ] = useState('')
  const [page, setPage] = useState(1)
  const [res, setRes] = useState(null)
  const [error, setError] = useState(null)

  useEffect(() => {
    const t = setTimeout(() => {
      const params = new URLSearchParams({ page, limit: 25, ...(q ? { q } : {}) })
      api(`/admin/users?${params}`)
        .then(setRes)
        .catch((e) => setError(e.message))
    }, 250)
    return () => clearTimeout(t)
  }, [q, page])

  const columns = [
    {
      key: 'full_name',
      label: 'Ad',
      render: (u) => <Link to={`/users/${u.id}`}>{u.full_name}</Link>,
    },
    { key: 'email', label: 'E-posta' },
    { key: 'role', label: 'Rol', render: (u) => <span className={`tag tag-${u.role}`}>{u.role}</span> },
    {
      key: 'status',
      label: 'Durum',
      render: (u) => <span className={`tag tag-${u.status}`}>{u.status}</span>,
    },
    { key: 'child_count', label: 'Cocuk' },
    { key: 'last_login_at', label: 'Son giris', render: (u) => fmtDate(u.last_login_at) },
    { key: 'created_at', label: 'Kayit', render: (u) => fmtDate(u.created_at) },
  ]

  return (
    <>
      <h1>Kullanicilar</h1>
      {error && <div className="alert">{error}</div>}
      <input
        className="search"
        placeholder="Ad veya e-posta ara..."
        value={q}
        onChange={(e) => {
          setQ(e.target.value)
          setPage(1)
        }}
      />
      <DataTable columns={columns} rows={res?.data} />
      <Pager meta={res?.meta} onPage={setPage} />
    </>
  )
}
